import * as React from 'react';
import PropTypes from 'prop-types';

import { Button, Table } from 'antd';

import Loader from 'shared/components/Loader/Loader';
import Search from 'shared/components/Search/Search';

import AddUserModal from '../../shared/AddUserModal/AddUserModal';

import s from './GroupUsers.pcss';
import { editGroupUserList, getUserListByGroup } from '../http';


const columns = [{
  title: 'Имя',
  dataIndex: 'fullName',
  width: '25%',
  render: (text, record) => (
    <div className={s.nameContainer}>
      <div className={s.name}>{text}</div>
      {record.groupArray &&
        <div className={s.tagList}>
          {record.groupArray.map(group => (
            <div key={group.id} className={s.tagItem}>{group.name}</div>
          ))}
        </div>
      }
    </div>
  ),
},
{
  title: 'E-mail',
  dataIndex: 'email',
  width: '25%',
},
{
  title: 'Должность',
  dataIndex: 'positionName',
  width: '25%',
  render: text => text || 'Не известно',
},
{
  title: 'Подразделение',
  dataIndex: 'unitId.name',
  width: '25%',
  render: text => text || 'Не известно',
}];

export default class GroupUsers extends React.Component {
  static propTypes = {
    group: PropTypes.shape().isRequired,
  };

  state = {
    selected: [],
    addUserMode: false,
    saving: false,
    loading: true,
    users: [],
    total: 0,
    page: 1,
    search: '',
  };

  componentWillMount() {
    this.loadUsers();
  }

  loadUsers = (stateParams) => {
    const { group } = this.props;
    const { page, search } = this.state;
    this.setState({ loading: true }, () => {
      getUserListByGroup(group.id, page - 1, search).then((data) => {
        const users = data.payload;
        this.setState({ users, total: data.total, loading: false, ...stateParams });
      });
    });
    return Promise.resolve();
  };

  addUsers = (selectedUsers) => {
    const { group } = this.props;
    const body = {
      id: group.id,
      addUserArray: selectedUsers.join(','),
    };
    return editGroupUserList(body)
      .then(() => this.loadUsers({ addUserMode: false, saving: false }));
  };

  removeAccess = () => {
    const { group } = this.props;
    const { selected } = this.state;
    const body = {
      id: group.id,
      deleteUserArray: selected.join(','),
    };
    this.setState({ saving: true }, () => {
      editGroupUserList(body)
        .then(() => this.loadUsers({ selected: [], saving: false }));
    });
  };

  handleSearch = search => this.setState(
    { search, page: 0 },
    () => this.loadUsers(),
  );

  onCloseModal = () => this.setState({ addUserMode: false });

  onOpenModal = () => this.setState({ addUserMode: true });

  onSelectChange = selected => this.setState({ selected });

  cancelSelection = () => this.setState({ selected: [] });

  changePage = ({ current }) => this.setState(
    { page: current },
    () => this.loadUsers(this.props.group.id)
      .then(({ users, total }) => {
        this.setState({ users, total, selected: [], saving: false });
        return Promise.resolve();
      }),
  );

  renderAddModalTitle = () => {
    const { group } = this.props;
    const name = group.name ? group.name : '';
    return (
      <div className={s.infoContainer}>
        <div className={s.groupName}>{name}</div>
      </div>
    );
  };

  render() {
    const { selected, addUserMode, users, search, page, total, saving } = this.state;
    const { group } = this.props;
    const rowSelection = !group.isLocked ? {
      selectedRowKeys: selected,
      onChange: this.onSelectChange,
    } : null;
    const disabledAdding = !this.props.group;
    const name = group ? group.name : '';
    const loading = {
      spinning: this.state.loading,
      indicator: <Loader fullScreen={false} size={20} />,
    };
    return (
      <div className={s.container}>
        <div className={s.title}>{name}</div>
        {!group.isLocked &&
          <div className={`${s.controls} ${selected.length > 0 ? s.selectedControls : ''}`}>
            {selected.length > 0 &&
              <div className={s.selectedCount}>
                {selected.length} значения выбрано
              </div>
            }
            <div className={s.searchContainer}>
              <Search onSearch={this.handleSearch} value={search} />
            </div>
            {!selected.length &&
              <Button
                type="primary"
                className={s.addBtn}
                disabled={disabledAdding}
                onClick={this.onOpenModal}
              >
                Добавить пользователей
              </Button>
            }

            <AddUserModal
              users={users.map(user => user.id)}
              title={this.renderAddModalTitle()}
              onAddUsers={this.addUsers}
              visible={addUserMode}
              withGroups={false}
              onClose={this.onCloseModal}
              onlyUsers
              filters={[]}
            />

            {selected.length > 0 && !saving ? (
              <div className={s.selectedBtns}>
                <div className={s.removeAccessBtn} onClick={this.removeAccess}>Удалить из группы</div>
                <div className={s.cancelAccessBtn} onClick={this.cancelSelection}>Отменить</div>
              </div>
            ) : null}
            {saving &&
              <div className={s.savingLoaderContainer}>
                <div className={s.savingLoader}>
                  <Loader fullScreen={false} size={30} />
                </div>
              </div>
            }
          </div>
        }
        {group.isLocked &&
          <div className={s.controls}>
            <div className={s.searchContainer}>
              <Search onSearch={this.handleSearch} />
            </div>
          </div>
        }
        <div className={s.tableContainer}>
          <Table
            rowKey={r => r.id}
            rowSelection={rowSelection}
            pagination={{ current: page, total }}
            columns={columns}
            onChange={this.changePage}
            loading={loading}
            dataSource={users}
            scroll={{ y: 'calc(100vh - 350px)' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/GroupUsers/GroupUsers.js